<template>
    <div class="getting-started">
        <section-header title="Getting Started" icon="fa-arrow-right"/>

        <ui-card>
            <p class="intro">You don't have any course enrollments or conference registrations yet. Here's where to find what you need.</p>

            <div class="info-box mt-4">
                <div class="box-main">
                    <div class="box-icon"><i class="fad fa-browsers fa-2x has-text-primary"></i></div>
                    <div class="box-body">
                        <div class="box-title">Online Course Catalog</div>
                        <div class="box-text">Online courses and offerings for the certifications and organizations you work with. Browse by category or build a custom bundle.</div>
                    </div>
                </div>
                <div class="box-actions">
                    <b-button type="is-primary" size="is-small" tag="router-link" :to="{name: 'course-catalog'}"><i class="fad fa-browsers mr-2"></i>Browse the Catalog</b-button>
                </div>
            </div>

            <div class="info-box mt-4">
                <div class="box-main">
                    <div class="box-icon"><i class="fad fa-presentation fa-2x has-text-primary"></i></div>
                    <div class="box-body">
                        <div class="box-title">Conference Center</div>
                        <div class="box-text">Register for in-person and on-demand conferences, clinics, and trainings, or get credit for one you've already attended.</div>
                    </div>
                </div>
                <div class="box-actions">
                    <b-button type="is-primary" size="is-small" tag="router-link" :to="{name: 'conference-center'}"><i class="fad fa-presentation mr-2"></i>Browse Conferences</b-button>
                </div>
            </div>
        </ui-card>
    </div>
</template>

<script>
    import SectionHeader from "../framework/SectionHeader";
    import UiCard from "../UiCard";

    // Empty-state card for a student with nothing enrolled or registered:
    // just the two places they can go to find something. Links to their
    // (empty) enrollments and registrations were dropped as pointless.
    export default {
        name: "GettingStarted",
        components: {SectionHeader, UiCard},
    };
</script>

<style lang="scss" scoped>
    .intro {
        color: #555;
    }
</style>
